import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRevert = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.26367 2.05963C7.58684 1.88405 8 2.11507 8 2.50104V3.76959L8.2627 3.77643C10.9654 3.91335 13.1151 6.14815 13.1152 8.88483C13.1152 11.7098 10.8249 13.9998 8 14.0001C5.17494 14.0001 2.88477 11.7099 2.88477 8.88483C2.88495 8.60884 3.10874 8.38483 3.38477 8.38483C3.66062 8.38504 3.88458 8.60897 3.88477 8.88483C3.88477 11.1576 5.72722 13.0001 8 13.0001C10.2726 12.9998 12.1152 11.1575 12.1152 8.88483C12.1151 6.68308 10.3854 4.88545 8.21094 4.77545L8 4.76959V6.03913C7.99996 6.45087 7.52977 6.68599 7.2002 6.43952L4.84082 4.66998C4.57447 4.47001 4.57453 4.0702 4.84082 3.87018L6.66602 2.50104L7.2002 2.10065L7.26367 2.05963Z",
		fill: "currentColor"
	})
});
export default SvgRevert;
